import { SidebarContext } from './types';

export const selectSidebarContext = (state) => state.sidebar?.sidebarContext;
export const selectIsSidebarOpen = (state) => state.sidebar?.isSidebarOpen;
export const selectSidebarView = (state) => state.sidebar?.sidebarView;
export const selectSidebarMessageStatus = (state) => state.sidebar?.messageStatus;

export const selectIsClaimsSidebarContext = (state) => state.sidebar?.sidebarContext === SidebarContext.CLAIMS;
